// extracted by mini-css-extract-plugin
module.exports = {"container":"ChildInfoBox_container__KR_Al","rowContainer":"ChildInfoBox_rowContainer__3fgwv","contactWrapper":"ChildInfoBox_contactWrapper__3-iT7"};